import { connect } from 'react-redux';

/**
 * Muestra un indicador mínimo mientras se valida la sesión (cookies + refresh).
 */
function SessionRestore({ sessionReady }) {
    if (sessionReady) {
        return null;
    }

    return (
        <div
            className="session-bootstrap"
            role="status"
            aria-live="polite"
            aria-label="Loading session"
        />
    );
}

const mapStateToProps = (state) => ({
    sessionReady: state.session.sessionReady,
});

export default connect(mapStateToProps)(SessionRestore);
